export function numberToTwoDecimalsLocaleString(someNumber: number, locale: Intl.LocalesArgument) {
  return someNumber.toLocaleString(locale, {maximumFractionDigits: 2});
}
